import { create } from 'zustand';

import { useFilePreviewStore } from './useFilePreviewStore';

/**
 * 回答正文文件卡片（FileChip）的预览状态。
 *
 * 和 useFilePreviewStore（角标 → PDFViewer + 高亮）刻意分开：
 * 那条链路靠后端 to_pdf 转换 + 高亮接口，这条链路是浏览器本地解析原文件的纯预览（FileViewer）。
 * 两个面板共用聊天页右侧的同一块位置，互斥：卡片打开前先清角标（FileChip 里做），
 * 角标打开时在 store 层关掉本面板（见文末订阅）——不能放在 FileViewer 的 effect 里，
 * 挂载处是 `file_id ? PDFViewer : FileViewer` 二选一，角标一开 FileViewer 就被卸载，effect 来不及跑。
 */
export interface FileViewerTarget {
  file_id: string;
  /** 文件名（含后缀），用于判定格式、标题与下载名；拿不到时由 FileViewer 按字节嗅探 */
  fileName?: string;
  /** 预览器页索引（从 0 起），pdf / pptx 打开后翻到这一页 */
  page?: number;
}

interface Store {
  file_id: string;
  fileName: string;
  page: number;
  open: (target: FileViewerTarget) => void;
  close: () => void;
}

export const useFileViewerStore = create<Store>()((set) => ({
  file_id: '',
  fileName: '',
  page: 0,
  open: ({ file_id, fileName = '', page = 0 }) => set({ file_id, fileName, page }),
  close: () => set({ file_id: '', fileName: '', page: 0 }),
}));

// 角标打开 PDFViewer 时收起本面板，否则关掉角标后会把上一次的卡片文件又弹出来
useFilePreviewStore.subscribe((state, prev) => {
  if (state.file_id && state.file_id !== prev.file_id) useFileViewerStore.getState().close();
});
